module.exports = __webpack_public_path__ + "static/bolinda-originals-1cad489ec25a142cfa316065732d711a.jpg";